<div class="ets-menu-toolbar">
  <i class="fas fa-ellipsis-v fa-lg" (click)="onContextMenuRequest($event)"></i>
  <i class="fas fa-sort-amount-up fa-lg" (click)="onSortPanelRequest($event)"></i>
</div>